import React from 'react';
import { Messages, Control, Code, Name, Title, Actions, Form, Files, Toast, Button, API, Utility, useListContext, useCallback, useEffect, useState, Hooks } from 'helpers/ListImports';
import { Purchase } from 'models/PurchaseModel';


const PurchaseList: React.FC = () => {
  const width = { sno: 10, supplier:15, count:10, amount: 10, tax: 10, payable: 10, date: 10, segment:10, createdby: 15 }
  const [formId, formName] = [Code.Form.Id.PURCHASE, Code.Form.Name.PURCHASE];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [purchaseData, setPurchaseData] = useState<Purchase[]>([]); 
  const [selectedPurchase, setselectedPurchase] = useState<Purchase | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const triggers = [pno, pageRows, search, activeId, userId];
  const Privilege = Hooks.Privilege.List(formId);
  const locationId = Utility.Storage.LocationId();
  
  Hooks.Privilege.HasView(Privilege);

  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.File.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Purchase.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Purchase.Number, 
        Name.Purchase.Date, 
        Name.Purchase.Count, 
        Name.Supplier.Id, 
        Name.Supplier.Name, 
        Name.Purchase.Gross,
        Name.Purchase.Tax1Amount,
        Name.Purchase.NetAmount,
        Name.Common.SegmentName,
        Name.User.FirstName,
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
    });
    await API.Data.List<Purchase>(url, setPurchaseData, setError, setLoading); 
 }, triggers);

 useEffect(()=>{
  //console.log("purchaseData:",purchaseData);
 },[purchaseData])

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId}  Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, purchaseData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.SNo, width.sno], 
                [Title.Supplier, width.supplier], 
                [Title.Count, width.count, Code.Align.CENTER],
                [Title.Amount, width.amount, Code.Align.RIGHT],
                [Title.Tax, width.tax, Code.Align.RIGHT],
                [Title.Payable, width.payable, Code.Align.RIGHT],
                [Title.Date, width.date],
                [Title.Segment, width.segment],
                [Title.CreatedBy, width.createdby]
              ]} last={1} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(purchaseData) && (
              <Control.Grid.Row>
                {purchaseData.map((purchaseData) => { return (
                  <Control.Grid.Data<Purchase> key={purchaseData.purchase_id} itemKey={purchaseData.purchase_key} data={purchaseData} setMenuPosition={setMenuPosition} setSelectedData={setselectedPurchase} setShowMenu={setShowMenu}>
                    <Control.Grid.Check keyId={purchaseData.purchase_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                    <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, purchaseData.purchase_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Items values={[
                      [purchaseData.purchase_number, width.sno],
                      [purchaseData.supplier_name, width.supplier],
                      [purchaseData.purchase_count, width.count, Code.Align.CENTER],
                      [Utility.Format.Amount(purchaseData.purchase_gross_amount), width.amount, Code.Align.RIGHT],
                      [Utility.Format.Amount(purchaseData.purchase_tax1_amount), width.amount, Code.Align.RIGHT],
                      [Utility.Format.Amount(purchaseData.purchase_net_amount), width.amount, Code.Align.RIGHT],
                      [Utility.Format.DateOnly(purchaseData.purchase_date), width.date], 
                      [purchaseData.segment_name, width.segment], 
                      [purchaseData.user_first_name, width.createdby], 
                    ]} /> 
                    <Control.Grid.Actions>
                      <Control.Action.All formName={formName} activeId={activeId} keyId={purchaseData.purchase_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                    </Control.Grid.Actions>
                  </Control.Grid.Data>)})}
              </Control.Grid.Row>
            )}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={purchaseData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, `${formName}/${selectedPurchase?.purchase_key}`)} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedPurchase?.purchase_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default PurchaseList;